
import  { useEffect, useState } from 'react';
import {  useLocation } from 'react-router-dom';
import { BiSolidUpArrowCircle } from "react-icons/bi";

function ScrollTop() {
  const [isVisible,setIsVisible]=useState(false);

  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo({left:0, top:0,behavior:'smooth'});
  }, [pathname]);

const listToScroll=()=>{

let heightToShow=250;
const winScroll=document.body.scrollTop || document.documentElement.scrollTop;


if(winScroll>heightToShow){

  setIsVisible(true);

}else{
  setIsVisible(false);
}

}

useEffect(()=>{
window.addEventListener('scroll',listToScroll);
return ()=>window.removeEventListener('scroll',listToScroll);

})


  return (
    <div>

  
{isVisible &&(
  <div className='fixed   z-[500] bottom-0 right-0 cursor-pointer' onClick={() => window.scrollTo({top:0, left:0,behavior:'smooth'})}>
  <BiSolidUpArrowCircle size={50}  className='animate-bounce text-red-600'/>
  </div>
)}
  


  </div>

  );
}
export default ScrollTop